<template>
  <div>
    <!-- Score introduction -->
    <section class="hero is-primary">
      <div class="container">
        <div class="hero-head has-text-centered">
          <h1 class="title">
            <strong>{{ chapter.title }}</strong>
          </h1>
        </div>
        <div class="hero-body">
          <p class="content is-medium" v-html="markdown(chapter.intro_text)"></p>

        </div>
      </div>
    </section>

    <!-- Score sliders -->
    <section class="section score-slideshow">
      <div class="container">
        <h3 class="title is-1">The Score</h3>
      </div>

      <agile>
        <!-- Slide template -->
        <router-link v-for="(score, index) in scores"
                     :to="`/chapter/${chapter.id}/score/${index + 1}/`"
                     :key="`score-${index}`"
                     :class="`slide--#{index + 1}`"
                     class="slide">

          <div class="slide-text has-text-centered">
            <h3 class="slide-title" v-if="score.title">{{ score.title }}</h3>
            <p v-if="score.author">{{ score.author }}</p>
          </div>

          <img v-if="score.image" :src="slideshowImage(score)" class="slide-image" />

        </router-link>
      </agile>

    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { markdown } from '@/utils.js'
export default {
  name: 'score',
  computed: {
    ...mapGetters(['chapter']),

    scores () {
      return require('@/assets/data/' + this.chapter.shortname + '/score.yml')
    },

    introImage () {
      return require(`@/assets/images/${this.chapter.shortname}/score/${this.chapter.intro_image}`)
    }
  },
  methods: {
    markdown: markdown,
    slideshowImage (slide) {
      return require('@/assets/images/' + this.chapter.shortname + '/score/' + slide.image)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.hero-head,
.hero-body {
  padding-left: 0;
  padding-right: 0;
}

.title {
  padding-top: 1em;
  padding-bottom: 1rem;
}

a,
a:hover {
  color: #fff;
}

</style>

<style lang="scss">
@import '../assets/styles/main.scss';

.section.score-slideshow {
  background-color: $black;
  padding-top: 0;

  .title { color: $dark-invert; }
}

.intro-image {
  margin-left: 2em;
  width: 40%;
}

.slide {
  color: #fff;
  height: 600px;
  position: relative;

  .slide-text {
    background: linear-gradient(to bottom,
                                rgba(0,0,0,0) 0%,
                                rgba(0,0,0,0.65) 100%);
    bottom: 0;
    left: 0;
    padding: 3rem 1rem 1rem;
    position: absolute;
    width: 100%;
    z-index: 100;

    .slide-title {
      font-size: $size-4;
    }
  }
}

.agile {
  &__arrow {
    background-color: transparent;
    height: 100%;
    top: 0;
    width: 80px;

    &:hover {
      background-color: rgba(#000, .5);
      #arrow-svg { fill: #fff; }
    }

    &[disabled] {
      display: none;
    }

    #arrow-svg {
      fill: rgba(#fff, .4);
      height: 25px;
    }
  }
}

// Agile dot styles get applied inline by the agile plugin;
// using !important to force override
.agile__dots { display: none !important; }

.slide-image {
  height: 100%;
  object-fit: contain;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Score.vue?05c7a119